import { Field, Widget } from '@kanda-libs/ks-component-ts';
import ItemTotal from './ItemTotal';

export const TITLE_VALIDATION = {
  required: {
    value: true,
    message: 'A main job description is required',
  },
  minLength: { value: 1, message: 'Description requires minimum length of 1' },
};

export const DESCRIPTION_VALIDATION = {
  minLength: { value: 1, message: 'Description requires minimum length of 1' },
};

export const PRICE_VALIDATION = {
  required: { value: true, message: 'Price is required.' },
  min: { value: 1, message: 'Price must be great than £0.00' },
};

export const VAT_VALIDATION = {
  required: { value: true, message: 'VAT Rate is required.' },
};

const EnquiryJobItems: React.FunctionComponent = function ({}) {
  return (
    <Widget.JobInfoJobItemsArrayWrapper>
      {({ fields, arrayName }) =>
        fields.map(({ id }, index) => (
          <div key={id} className="flex flex-col">
            <Field.Array.Input index={index} name="title">
              <Field.Validator validation={TITLE_VALIDATION}>
                <Field.Input
                  label="Main job description"
                  placeholder="Please tell us the main work of this job"
                />
              </Field.Validator>
            </Field.Array.Input>
            <Field.Array.Input index={index} name="description">
              <Field.Validator validation={DESCRIPTION_VALIDATION}>
                <Field.TextAreaInput
                  label="Brief description of work (optional if not provided)"
                  placeholder="A quick summary of the work to be"
                  rows={6}
                />
              </Field.Validator>
            </Field.Array.Input>
            <div className="flex flex-col md:flex-row gap-x-4">
              <Field.Array.Input index={index} name="price.amount">
                <Field.Validator validation={PRICE_VALIDATION}>
                  <Field.NumberInput
                    type="price"
                    label="Job Total (exc. VAT)"
                    placeholder="A quick summary of the work to be"
                  />
                </Field.Validator>
              </Field.Array.Input>
              <Field.Array.Input index={index} name="vat_rate">
                <Field.Validator validation={VAT_VALIDATION}>
                  <Field.Select
                    label="VAT Rate"
                    options={[
                      { name: 'Vat Not Set', value: 'vat_not_set' },
                      { name: 'Exempted', value: 'exempted' },
                      { name: '0%', value: '0%' },
                      { name: '5%', value: '5%' },
                      { name: '20%', value: '20%' },
                      { name: 'Custom', value: 'custom' },
                    ]}
                    placeholder="Select..."
                  />
                </Field.Validator>
              </Field.Array.Input>
            </div>
            <ItemTotal index={index} arrayName={arrayName} />
          </div>
        ))
      }
    </Widget.JobInfoJobItemsArrayWrapper>
  );
};

export default EnquiryJobItems;
